import { useTranslation } from "react-i18next";
import IconButton from "../../components/IconButton/IconButton";
import Grid from "../../config/Grid/Grid";
import styles from "./Feedback.module.scss";
import Rating from "../../components/Rating/Rating";
import RatingComponent from "../../components/RatingComponent/RatingComponent";
import DynamicForm from "../../components/DynamicForm/DynamicForm";
import { FeedbackFormConfig } from "./FeedbackFormConfig";

function Feedback() {
  const { t } = useTranslation();

  const formConfig = FeedbackFormConfig(t);

  return (
    <Grid>
      <div className={`start-1 col-4 ${styles.feedbackWrapper}`}>
        <div className={styles.feedbackHeader}>
          <IconButton
            iconName=""
            onClick={() => {}}
            color="primary"
            variant="text"
          />

          <p className={`body-bold-large ${styles.feedbackTitle}`}>
            {t("feedback.title")}
          </p>
          <IconButton
            iconName="las la-angle-right icon-big"
            onClick={() => {}}
            color="primary"
            variant="text"
          />
        </div>
        <div className={styles.feedbackContent}>
          <div className={styles.contentHeader}>
            <p className={`title-medium ${styles.feedbackHeaderDescription}`}>
              {t("feedback.header.description")}
            </p>
            <Rating />
          </div>
          <div className={styles.contentBody}>
            <p className={`title-medium ${styles.feedbackDescription}`}>
              {t("feedback.content.descriptionFirstPart")}
            </p>
            <div className={styles.feedbackDescriptionContainer}>
              <p className={`title-medium ${styles.feedbackDescription}`}>
                {t("feedback.content.descriptionSecondPart")}
              </p>
              <p className={`title-bold-medium ${styles.feedbackDescription}`}>
                Philip
              </p>
            </div>
            <div className={styles.feedbackRatingContainer}>
              <RatingComponent
                label={t("feedback.content.foodsAndDrinks")}
                renderDirection="row"
              />
              <RatingComponent
                label={t("feedback.content.service")}
                renderDirection="row"
              />
              <RatingComponent
                label={t("feedback.content.ambiance")}
                renderDirection="row"
              />
            </div>
            <div className={styles.feedbackFormContainer}>
              <DynamicForm setButtonDisabled={() => {}} {...formConfig} />
            </div>
          </div>
        </div>
      </div>
    </Grid>
  );
}

export default Feedback;
